import { TableBody, TableCell, TableRow } from "@windmill/react-ui";
import { notifySuccess, notifyError } from '../../utils/toast'; // adjust path
import MainDrawer from "components/drawer/MainDrawer";

import DeleteModal from "components/modal/DeleteModal";
import EditDeleteButton from "components/table/EditDeleteButton";
import useToggleDrawer from "hooks/useToggleDrawer";
import React from "react";
import CityLinkServices from "services/CityLink";


const CityLinkTable = ({
  CityLinkdata,
  hideDelete,
  hideEdit,
}) => {
  const { title, serviceId, handleModalOpen, handleUpdate } = useToggleDrawer();

const handleGetLink = async (cityId) => {
  try {
    const res = await CityLinkServices.generateCityLink(cityId);
 

    if (res) {

      const city = res.data[0];
      const link = city.link;
      const name = city.name;
   
try {
    await navigator.clipboard.writeText(link);
    notifySuccess(`City link for "${name}" copied to clipboard!`);
  } catch (err) {
    console.error("Failed to copy:", err);
    notifyError(`Failed to copy link for "${name}"`);
  }
    } else {
      // Show error toast if API returned failure
      const message = res?.data?.message || 'Failed to get city link';
      notifyError(message);
    }
  } catch (error) {
    console.error('Error fetching city link:', error);
    notifyError('Error fetching city link');
  }
};


  return (
    <>
      <DeleteModal id={serviceId} title={title} />

      <TableBody>
        {CityLinkdata?.slice(0, ).map((data, index) => (
        
          
          <TableRow key={data.id}>
            <TableCell className="text-center text-xs">
              { index + 1}
            </TableCell>

            <TableCell className="text-center text-xs">
              {data.name}
            </TableCell>
          
  <TableCell className="text-center">
            <span
              className="text-blue-500 cursor-pointer hover:underline"
              onClick={() => handleGetLink(data.id_city)}
            >
             Copy link
            </span>
          </TableCell>

          </TableRow>
        ))}
      </TableBody>
    </>
  );
};

export default CityLinkTable;
